import GetInTouch from "./get-in-touch/GetInTouch";
import { useEffect, useState } from "react";
import OurTopPicks from "./our-top-picks/OurTopPicks";
import WhyDTFSection from "./why-DTF-section/WhyDTFSection";
import CreativePowerSection from "./creative-power/CreativePowerSection";
import BlankApparelSection from "./blank-apparel-carousel/BlankApparelSection";
import OurStandoutFeatures from "./our-standouts/OurStandoutFeatures";
import OurOffices from "./our-offices/OurOffices";
import FAQs from "./FAQS/FAQs";
import SocialSection from "./social-section/SocialSection";
import HappyGuarantee from "./happy-guarantee/HappyGuarantee";
import { getPageAction } from "src/utils/getPageData";
import { endpoints } from "src/libs/axios";
import WhyWeMust from "./why-wemust/WhyWEMust";

const HomePageSections = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [pageData, setPageData] = useState([]);
  useEffect(() => {
    const onScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const getData = async () => {
      const response = await getPageAction(endpoints?.pages?.homePage);
      setPageData(response?.pageSection);
    };

    getData();
  }, []);

  const _renderSection = (section: any) => {
    switch (section.name) {
      // case "Our_Trusted_Brands":
      //   return <LogoScroller data={section?.meta?.data} />;
      case "Our_Top_Categories_Section":
        return <OurTopPicks data={section?.meta?.data} />;
      case "Why_DTF_From_We_Must":
        return <WhyDTFSection data={section?.meta?.data} />;
      case "Creative_Power_Section":
        // Skip rendering Creative Power here as it's already rendered after FAQs
        return null;
      case "Blank_Apparel_Section":
        return <BlankApparelSection data={section?.meta?.data} />;
      case "Our_Standout_Features":
        return <OurStandoutFeatures data={section?.meta?.data} />;
      case "Happiness_Guarantee_Testimonials":
        const faqSection = pageData?.find(
          (s: any) => s.name === "FAQS_SECTION",
        ) as any;
        return (
          <>
            <HappyGuarantee data={section?.meta?.data} />
            {faqSection && (
              <div id={faqSection?.title} key={faqSection?.title}>
                <FAQs data={faqSection?.meta?.data} />
              </div>
            )}
            <div key="creative-power-section">
              <CreativePowerSection />
            </div>
          </>
        );
      case "Social_Section":
        return <SocialSection data={section?.meta?.data} />;
      case "GET_IN_TOUCH_SECTION":
        return <GetInTouch data={section?.meta?.data} />;

      case "OUR_OFFICES_SECTION":
        return <OurOffices data={section?.meta?.data} />;
      case "WHY_WE_MUST":
        return <WhyWeMust data={section?.meta?.data} />;
      case "FAQS_SECTION":
        // Skip rendering FAQs here as it's already rendered after Happiness Guarantee
        return null;
      default:
        return null;
    }
  };
  return (
    // <div
    //   style={{
    //     ...(isScrolled ? { marginTop: "404px" } : { marginTop: "-64px" }),
    //   }}
    // >
    <div>
      {pageData?.map((section: any) => {
        const renderedSection = _renderSection(section);
        if (renderedSection === null) return null;
        return (
          <div id={section?.title} key={section?.title}>
            {renderedSection}
          </div>
        );
      })}
    </div>
  );
};

export default HomePageSections;
